import { render, staticRenderFns } from "./c-links-chips.vue?vue&type=template&id=7e0a4a10&"
import script from "./c-links-chips.vue?vue&type=script&lang=js&"
export * from "./c-links-chips.vue?vue&type=script&lang=js&"
import style0 from "./c-links-chips.vue?vue&type=style&index=0&id=7e0a4a10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports